import React from "react";
// import flexible from '../../utils/flexible';
import "./index.less";
import hic_mobile_pic2 from "./img/20230609.jpg";

class Banner20230609 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    // document.title = '充电安全须知';
    return (
      <div id="banner">
        <img src={hic_mobile_pic2} />
      </div>
    );
  }
}

export default Banner20230609;



// WEBPACK FOOTER //
// ./src/staticPage/banner/20230609/index.js